import React from "react";
import { useTranslation } from "react-i18next";

const CONTACT_EMAIL = "contact@tabletalk.app";

export default function Contact() {
  return (
    <main>
      <Hero />
    </main>
  );
}

function Hero() {
  const { t } = useTranslation();
  return (
    <section style={{ background: "var(--bg)" }}>
      <div className="container" style={{ padding: "56px 24px 160px" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 12, fontFamily: "Inter, sans-serif", fontSize: 12, fontWeight: 500, letterSpacing: ".22em", textTransform: "uppercase", color: "var(--persimmon)" }}>
          <span style={{ width: 22, height: 1, background: "var(--persimmon)" }} />
          {t("contact.eyebrow")}
        </div>
        <h1 className="tt-h tt-h-xl" style={{ marginTop: 24 }}>
          {t("contact.headline")}<br />
          <span style={{ fontFamily: "Fraunces, serif", fontStyle: "italic", fontWeight: 400 }}>{t("contact.headlineItalic")}</span>
        </h1>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          style={{
            display: "inline-block",
            marginTop: 40,
            fontFamily: "Satoshi, Inter, sans-serif",
            fontWeight: 600,
            fontSize: "clamp(20px, 1.8vw, 26px)",
            letterSpacing: "-0.01em",
            color: "var(--persimmon)",
            textDecoration: "none",
            borderBottom: "1px solid var(--persimmon)",
            paddingBottom: 4
          }}
        >
          {CONTACT_EMAIL}
        </a>
      </div>
    </section>
  );
}
